import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-grow flex-col overflow-hidden h-full" }
const _hoisted_2 = {
  class: "overflow-auto",
  "data-ui": "ekb-list"
}
const _hoisted_3 = ["data-ui", "onClick"]
const _hoisted_4 = { class: "pl-4 w-full cursor-pointer" }

import router from "@/router";
import {computed, onMounted, ref, watch} from "vue"
import {useRoute} from 'vue-router';
import {query} from "@/graphql";
import { useStore } from "vuex"; // <-- DIESER IMPORT FEHLT
import AccordionSimpleItem from "@/components/Accordion/AccordionSimpleItem.vue";
import TRInput from "@/components/Base/TRInput.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'STable',
  props: {
  accordionIndex: {
    type: Number,
    default: () => {
    }
  },
},
  setup(__props) {


const tables = ref<string[]>([]);
const tableSearch = ref("");
const selectedTable = ref(null);
const store = useStore();
const userData = computed(() => store.state.user.userData);
const route = useRoute();

const filteredTables = computed(() => {
  if (!tableSearch.value) {
    return tables.value;
  }
  return tables.value.filter(table =>
    table.toLowerCase().includes(tableSearch.value.toLowerCase())
  );
});

const props = __props;

async function getTables() {

  const [data,error] = await query.getTablesFromDatabase()
  if (error) {
    console.error("Error fetching tables:", error);
    return;
  }
  tables.value = data;
}

function navigateTo(route, params = {}) {
  let path = route;
  if (Object.keys(params).length) {
    const paramParts = Object.keys(params).map(key => params[key]);
    path += '/' + paramParts.join('/');
  }
  router.push(path);
}
onMounted(async () => {
 await getTables();
 //  selectedTable.value  == url param
  selectedTable.value = route.params.tableName;
})


watch(() => route.params.tableName, (newVal) => {
  selectedTable.value = newVal;
});

/*
created() {
    this.teamId =  this.$route.params.teamId
  },
  watch: {
    '$route.params': {
      handler: function (params) {
        this.teamId = params.teamId;
      },
    },
  },
 */




return (_ctx: any,_cache: any) => {
  return (userData.value?.isSuperAdmin)
    ? (_openBlock(), _createBlock(AccordionSimpleItem, {
        key: 0,
        title: "Datenbank",
        flex: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(TRInput, {
              modelValue: tableSearch.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tableSearch).value = $event)),
              type: "text",
              placeholder: "Tabelle suchen...",
              class: "p-2 w-full my-2",
              "data-ui": "search-ekb-input"
            }, null, 8, ["modelValue"]),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (navigateTo(`/administration/${__props.accordionIndex}/createSQLSkript`))),
              class: "p-1 bg-white mb-4 mt-2 w-full hover:bg-trader-blue hover:text-white",
              "data-ui": "create-new-EKB"
            }, " Neue Abfrage erstellen "),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTables.value, (table, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: table,
                  "data-ui": 'navigate-to'+ table,
                  onClick: ($event: any) => (navigateTo(`/administration/${__props.accordionIndex}/superAdmin`, { tableName: table })),
                  class: _normalizeClass(["w-full p-1 flex my-2", { 'bg-trader-blue text-white': table === selectedTable.value, 'bg-trader-dark-gray': table !== selectedTable.value }])
                }, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(table), 1)
                ], 10, _hoisted_3))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})